"use client";

import { SLATE_XP_REDRAWN_ICONS_BETA } from "@faire/web/slate/icons/lib/SLATE_XP_REDRAWN_ICONS";

import { Globe as GlobeControl } from "./__internal__/Globe.control";
import { Globe as GlobeTreatment } from "./__internal__/Globe.treatment";

/** @deprecated use `@faire/slate/icons/Globe` instead (legacy Slate foundation icons cannot be deleted from code even if unused in frontend because they may be referenced to in Builder.io page data) */
export const Globe = SLATE_XP_REDRAWN_ICONS_BETA.icon({
  control: GlobeControl,
  treatment: GlobeTreatment,
});
